export default "__VITE_ASSET__DF2Niaa9__"